import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { CreateOrganizationTitleDto } from 'api/dtos/organizations/titles';
import { Form, Formik } from 'formik';
import Field from 'legacy/common/components/wysiwyg-form/Field';
import TextareaAutosize from 'legacy/common/components/wysiwyg-form/TextareaAutoSize';
import ToggleField from 'legacy/common/components/wysiwyg-form/ToggleField';
import Button from 'components/Button';
import { BiSolidTrashAlt } from 'react-icons/bi';
import Error from 'legacy/common/components/wysiwyg-form/Error';

import _get from 'lodash/get';

interface Props {
  isLoading?: boolean;
  isDeleting?: boolean;
  initialValues?: CreateOrganizationTitleDto;
  onSubmit: (values: any) => void;
  onDelete?: () => void;
}

const OrganizationTitleForm = ({
  initialValues,
  isLoading,
  isDeleting,
  onSubmit,
  onDelete
}: Props) => {
  const { t } = useTranslation(['organizations']);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(t('titleForm.nameRequired')),
    description: Yup.string().required(t('titleForm.descriptionRequired')),
    isVisible: Yup.boolean().required(t('titleForm.visibilityRequired'))
  });

  return (
    <div className="px-10">
      <Formik
        initialValues={
          initialValues || {
            name: '',
            description: '',
            isVisible: true
          }
        }
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ submitForm, errors, touched }) => (
          <Form>
            <Field
              label={t('titleForm.titleName')}
              id="name"
              name="name"
              placeholder={t('titleForm.titleNamePlaceholder')}
            />

            <div className="text-sm font-normal">
              {t('titleForm.titleResponsibilities')}
            </div>
            <TextareaAutosize
              id="description"
              name="description"
              placeholder={t('titleForm.titleResponsibilitiesPlaceholder')}
            />
            <div className="-mt-4 mb-8">
              {errors.description && touched.description && (
                <Error error={_get(errors, 'description')} />
              )}
            </div>

            <ToggleField
              name="isVisible"
              label={t('titleForm.displayOnOrgPage')}
              labelClassName="text-base font-normal font-medium"
            />

            <div className="absolute bottom-0 left-0 right-0 w-full flex items-center justify-center py-10 px-4">
              <div className="w-full md:w-[343px]">
                {onDelete && (
                  <Button
                    variant="inverted"
                    onClick={onDelete}
                    className="w-full mb-4"
                    disabled={isLoading || isDeleting}
                  >
                    <BiSolidTrashAlt className="mr-2" />
                    {t('titleManagement.deleteExecutiveTitle')}
                  </Button>
                )}

                <Button
                  variant="primary"
                  onClick={submitForm}
                  className="w-full"
                  disabled={isLoading || isDeleting}
                >
                  {t('titleManagement.save')}
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default OrganizationTitleForm;
